import {useParams} from 'react-router-dom';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {DocumentsBrowserShell} from 'src/app/documents/DocumentsBrowserShell';
import {toDocumentTreeNodeId} from 'src/app/documents/documentTreeBrowserState';
import {DocumentFolderForm} from 'src/pages/Modules/DocumentManagement/shared/DocumentFolderForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {documentTitle} from '../documentHelpers';

export const EditFolderPage = () => {
  useSetDocumentTitle(documentTitle);
  const {id} = useParams();

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.DocumentManagement}>
      <DocumentsBrowserShell selectedId={toDocumentTreeNodeId(id)}>
        <DocumentFolderForm mode="edit" id={Number(id)} />
      </DocumentsBrowserShell>
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.DocumentManagerEditFolder(':id'),
  element: <EditFolderPage />,
  module: ModuleEnum.Documents,
  operation: PermissionOperationEnum.Update,
  isPrivate: true,
});
